const PAYMENT_SESSION_KEYS = [
  'nf_checkout_plan',
  'nf_checkout_billing',
  'nf_checkout_method',
  'nf_checkout_confirmed_pricing',
  'nf_checkout_confirmed_address',
  'nf_checkout_show_address_modal',
  'nf_checkout_address_modal_state',
  'nf_checkout_selected_address_id',
];

// PayPal-related sessionStorage keys
const PAYPAL_SESSION_KEYS = [
  'paypal_verification_start_time',
  'paypal_verification_token',
  'paypal_redirect_start_time',
  'paypal_completed_payment',
];

// PayPal-related localStorage keys
const PAYPAL_LOCAL_KEYS = [
  'paypal_pending_order',
];


//  Clear all payment checkout session storage
export const clearCheckoutSession = () => {
  PAYMENT_SESSION_KEYS.forEach(key => {
    sessionStorage.removeItem(key);
  });
};

//  Clear all PayPal session storage
export const clearPayPalSessionStorage = () => {
  PAYPAL_SESSION_KEYS.forEach(key => {
    sessionStorage.removeItem(key);
  });
};

//  Clear all PayPal local storage
export const clearPayPalLocalStorage = () => {
  PAYPAL_LOCAL_KEYS.forEach(key => {
    localStorage.removeItem(key);
  });
};


export const clearAllPaymentStorage = () => {
  
  clearCheckoutSession();
  clearPayPalSessionStorage();
  clearPayPalLocalStorage();
};

export const clearAllPaymentStorageWithLogging = () => {
  
  const allKeys = [
    ...PAYMENT_SESSION_KEYS,
    ...PAYPAL_SESSION_KEYS,
    ...PAYPAL_LOCAL_KEYS,
  ];
  
  allKeys.forEach(key => {
    const isLocal = PAYPAL_LOCAL_KEYS.includes(key);
    const storage = isLocal ? localStorage : sessionStorage;
    if (storage.getItem(key)) {
      storage.removeItem(key);
    }
  });
};
